import React from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import BasicSystemTableMonthCellWrapper, {
  BasicSystemConfiguratorItem,
  BasicSystemTableMonthCellWrapperProps,
} from 'src/Libs/shop/components/SystemConfiguration/BasicSystem/BasicSystemTableMonthCellWrapper'

type QntmBasicSystemTableMonthCellProps = Omit<BasicSystemTableMonthCellWrapperProps, 'configuratorItems'>

const QntmBasicSystemTableMonthCell: React.FC<QntmBasicSystemTableMonthCellProps> = props => {
  const configuratorItems: BasicSystemConfiguratorItem[] = useTypedSelector(state =>
    state.qntmStorage.items.map(item => ({
      desiredShippingDate: item.desiredShippingDate,
      configuration: {
        configuratorId: item.configuration.configuratorId,
      },
    }))
  )

  return <BasicSystemTableMonthCellWrapper {...props} configuratorItems={configuratorItems} />
}

export default QntmBasicSystemTableMonthCell
